module.exports = __webpack_public_path__ + "static/img/dibubgc.863b1085.png";